import { render, staticRenderFns } from "./index_GLYF.vue?vue&type=template&id=080f9ea4&scoped=true"
import script from "./index_GLYF.vue?vue&type=script&lang=js"
export * from "./index_GLYF.vue?vue&type=script&lang=js"
import style0 from "./index_GLYF.vue?vue&type=style&index=0&id=080f9ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f9ea4",
  null
  
)

export default component.exports